import React, { useEffect, useRef, useState } from "react";

export const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "hi", label: "Hindi" },
  { value: "hinglish", label: "Hinglish" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
  { value: "de", label: "German" },
  { value: "zh", label: "Chinese" },
  { value: "ja", label: "Japanese" },
  { value: "ar", label: "Arabic" },
];

// ── Custom Language Dropdown ────────────────────────────────────────────────
const LangSelect = ({ value, onChange, dark = false }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = LANGUAGES.find(l => l.value === value) || LANGUAGES[0];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className={`lang-select-wrap${dark ? " lang-select-dark" : ""}`}>
      <button type="button" className="lang-select-btn" onClick={() => setOpen(o => !o)}>
        <span>{selected.label}</span>
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, transition: "transform 0.15s", transform: open ? "rotate(180deg)" : "rotate(0deg)" }}><polyline points="6 9 12 15 18 9" /></svg>
      </button>
      {open && (
        <ul className="lang-select-menu">
          {LANGUAGES.map(l => (
            <li key={l.value} className={`lang-select-option${l.value === value ? " active" : ""}`} onClick={() => { onChange(l.value); setOpen(false); }}>
              {l.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LangSelect;
